import { render, staticRenderFns } from "./RestoreForm.vue?vue&type=template&id=7240d393&scoped=true"
import script from "./RestoreForm.vue?vue&type=script&lang=js"
export * from "./RestoreForm.vue?vue&type=script&lang=js"
import style0 from "./RestoreForm.vue?vue&type=style&index=0&id=7240d393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7240d393",
  null
  
)

export default component.exports